import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.componentExtactor)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.componentExtactor), _mergeProps({ key: 0 }, $setup.params, { close: $setup.close }), null, 16, ["close"]))
    : _createCommentVNode("", true)
}